/* Montador DTF · Imprimirlo
 * El cliente sube PNG e indica ancho y cantidad. Aquí se recortan los márgenes transparentes,
 * se comprueba la resolución, se colocan las piezas (3 mm, con giro) y se elige el formato más barato.
 * Los PNG llegan al pedido como propiedades de línea (subida nativa de Shopify, multipart).
 */
(function () {
  'use strict';

  /* ---------- Colocación: MaxRects (Best Short Side Fit) con giro ---------- */
  function MaxRects(W, H) { this.free = [{ x: 0, y: 0, w: W, h: H }]; }
  MaxRects.prototype.find = function (w, h, rot) {
    var best = null, bs = Infinity, bl = Infinity;
    for (var i = 0; i < this.free.length; i++) {
      var f = this.free[i], s, l;
      if (w <= f.w + 1e-9 && h <= f.h + 1e-9) {
        s = Math.min(f.w - w, f.h - h); l = Math.max(f.w - w, f.h - h);
        if (s < bs || (s === bs && l < bl)) { best = { x: f.x, y: f.y, w: w, h: h, r: false }; bs = s; bl = l; }
      }
      if (rot && w !== h && h <= f.w + 1e-9 && w <= f.h + 1e-9) {
        s = Math.min(f.w - h, f.h - w); l = Math.max(f.w - h, f.h - w);
        if (s < bs || (s === bs && l < bl)) { best = { x: f.x, y: f.y, w: h, h: w, r: true }; bs = s; bl = l; }
      }
    }
    return best;
  };
  MaxRects.prototype.place = function (n) {
    var out = [];
    this.free.forEach(function (f) {
      if (n.x >= f.x + f.w || n.x + n.w <= f.x || n.y >= f.y + f.h || n.y + n.h <= f.y) { out.push(f); return; }
      if (n.x > f.x) out.push({ x: f.x, y: f.y, w: n.x - f.x, h: f.h });
      if (n.x + n.w < f.x + f.w) out.push({ x: n.x + n.w, y: f.y, w: f.x + f.w - n.x - n.w, h: f.h });
      if (n.y > f.y) out.push({ x: f.x, y: f.y, w: f.w, h: n.y - f.y });
      if (n.y + n.h < f.y + f.h) out.push({ x: f.x, y: n.y + n.h, w: f.w, h: f.y + f.h - n.y - n.h });
    });
    this.free = out.filter(function (a, i) {
      for (var j = 0; j < out.length; j++) {
        if (i === j) continue;
        var b = out[j];
        if (a.x >= b.x && a.y >= b.y && a.x + a.w <= b.x + b.w && a.y + a.h <= b.y + b.h) {
          var same = a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
          if (!same || j < i) return false;
        }
      }
      return true;
    });
  };

  /* La separación se suma a cada pieza y a la hoja (W+gap), así queda gap entre piezas y 0 en el borde. */
  function packOnce(pieces, W, H, gap) {
    var bins = [], packers = [];
    for (var i = 0; i < pieces.length; i++) {
      var p = pieces[i], pos = null, k;
      for (k = 0; k < packers.length; k++) {
        pos = packers[k].find(p.w + gap, p.h + gap, true);
        if (pos) break;
      }
      if (!pos) {
        packers.push(new MaxRects(W + gap, H + gap)); bins.push([]);
        k = packers.length - 1;
        pos = packers[k].find(p.w + gap, p.h + gap, true);
        if (!pos) return null;
      }
      packers[k].place(pos);
      bins[k].push({ logo: p.logo, x: pos.x, y: pos.y, w: pos.r ? p.h : p.w, h: pos.r ? p.w : p.h, r: pos.r });
    }
    return bins;
  }

  /* COLOCACIÓN POR FILAS, la de toda la vida.
   *
   * MaxRects es listo con piezas de tamaños distintos, pero cuando son todas
   * iguales —que es el caso corriente: 21 redondas del mismo logo— reparte los
   * huecos como le da la gana y el montaje sale a trozos: tres filas llenas,
   * luego dos columnas sueltas y medio pliego en blanco. Cabe lo mismo, pero
   * parece que estás tirando film y, si luego se corta a mano, es peor.
   *
   * Así que se prueba también lo que haría cualquiera con las piezas en la
   * mesa: llenar una fila, bajar, llenar la siguiente. Se queda el que use
   * menos hojas y, a igualdad, el que ocupe menos alto. */
  function packFilas(pieces, W, H, gap) {
    var bins = [[]], x = 0, y = 0, altoFila = 0;
    for (var i = 0; i < pieces.length; i++) {
      var p = pieces[i], w = p.w + gap, h = p.h + gap, r = false;
      // si girada entra mejor en lo que queda de fila, se gira
      if (w > W + gap - x && p.h + gap <= W + gap - x && p.w !== p.h) { w = p.h + gap; h = p.w + gap; r = true; }
      if (x + w > W + gap + 1e-9) {                 // no cabe: fila nueva
        x = 0; y += altoFila; altoFila = 0;
        w = p.w + gap; h = p.h + gap; r = false;
      }
      if (y + h > H + gap + 1e-9) {                 // no cabe: hoja nueva
        if (!bins[bins.length - 1].length) return null;   // ni en una hoja vacía: no cabe
        bins.push([]); x = 0; y = 0; altoFila = 0;
      }
      if (x + w > W + gap + 1e-9 || y + h > H + gap + 1e-9) return null;
      bins[bins.length - 1].push({ logo: p.logo, x: x, y: y, w: r ? p.h : p.w, h: r ? p.w : p.h, r: r });
      x += w;
      if (h > altoFila) altoFila = h;
    }
    return bins;
  }

  // lo que ocupa de alto el montaje: es lo que se paga cuando el film va en rollo
  function altoUsado(bins) {
    return bins.reduce(function (t, b) {
      return t + b.reduce(function (m, p) { return Math.max(m, p.y + p.h); }, 0);
    }, 0);
  }

  /* EL FILM QUE SOBRA TIENE QUE QUEDAR ABAJO, JUNTO.
   *
   * Da igual cómo reparta MaxRects: al final cada pieza se deja caer hacia
   * arriba y luego hacia la izquierda hasta tocar otra o el borde, y se repite
   * hasta que nada se mueve. Queda el montaje leído de arriba abajo y de
   * izquierda a derecha, y todo el film libre en una sola franja al final, que
   * es lo que se puede guardar para el siguiente pedido. */
  function compacta(bins, W, H, gap) {
    bins.forEach(function (b) {
      var moved = true, vueltas = 0;
      function choca(p, x, y) {
        if (x < 0 || y < 0 || x + p.w + gap > W + gap + 1e-9 || y + p.h + gap > H + gap + 1e-9) return true;
        for (var j = 0; j < b.length; j++) {
          var q = b[j];
          if (q === p) continue;
          if (x < q.x + q.w + gap - 1e-9 && q.x < x + p.w + gap - 1e-9 &&
              y < q.y + q.h + gap - 1e-9 && q.y < y + p.h + gap - 1e-9) return true;
        }
        return false;
      }
      while (moved && vueltas++ < 50) {
        moved = false;
        b.sort(function (a, c) { return a.y - c.y || a.x - c.x; });
        b.forEach(function (p) {
          // salta a la posición más alta posible: primero a ras de lo que tiene encima, luego a 0
          var ys = [0].concat(b.map(function (q) { return q.y + q.h + gap; }));
          ys.sort(function (a, c) { return a - c; });
          for (var i = 0; i < ys.length && ys[i] < p.y - 1e-9; i++) {
            if (!choca(p, p.x, ys[i])) { p.y = ys[i]; moved = true; break; }
          }
          var xs = [0].concat(b.map(function (q) { return q.x + q.w + gap; }));
          xs.sort(function (a, c) { return a - c; });
          for (i = 0; i < xs.length && xs[i] < p.x - 1e-9; i++) {
            if (!choca(p, xs[i], p.y)) { p.x = xs[i]; moved = true; break; }
          }
        });
      }
      b.sort(function (a, c) { return a.y - c.y || a.x - c.x; });
    });
    // las hojas llenas primero; la última es la que sobra
    bins.sort(function (a, c) { return altoUsado([c]) - altoUsado([a]); });
    return bins;
  }

  function pack(pieces, W, H, gap) {
    var orders = [
      function (a, b) { return (b.w * b.h) - (a.w * a.h); },
      function (a, b) { return Math.max(b.w, b.h) - Math.max(a.w, a.h); },
      function (a, b) { return b.h - a.h || b.w - a.w; },
      function (a, b) { return b.w - a.w || b.h - a.h; }
    ];
    var best = null;
    function mira(res) {
      if (!res) return;
      if (!best) { best = res; return; }
      /* PRIMERO LO QUE CUESTA DINERO —las hojas— y solo después lo que se ve.
         Sin el segundo criterio el montaje salía desparramado aunque cupiera
         en el mismo sitio. */
      if (res.length < best.length) { best = res; return; }
      if (res.length === best.length && altoUsado(res) < altoUsado(best)) best = res;
    }
    orders.forEach(function (o) {
      var orden = pieces.slice().sort(o);
      var a = packOnce(orden, W, H, gap), f = packFilas(orden, W, H, gap);
      mira(a && compacta(a, W, H, gap));
      mira(f && compacta(f, W, H, gap));
    });
    return best;
  }

  /* Combinación más barata de packs de metros que cubra al menos m metros. packs: [{id, m, price, title}] */
  function cheapestMetres(m, packs) {
    var top = m + Math.max.apply(null, packs.map(function (p) { return p.m; }));
    var cost = [0], pick = [null], L;
    for (L = 1; L <= top; L++) {
      cost[L] = Infinity; pick[L] = null;
      packs.forEach(function (p) {
        var prev = Math.max(0, L - p.m);
        if (cost[prev] + p.price < cost[L]) { cost[L] = cost[prev] + p.price; pick[L] = { pack: p, prev: prev }; }
      });
    }
    var bestL = m;
    for (L = m; L <= top; L++) if (cost[L] < cost[bestL]) bestL = L;
    var lines = {}, cur = bestL;
    while (cur > 0 && pick[cur]) {
      var pk = pick[cur].pack;
      if (!lines[pk.id]) lines[pk.id] = { variant: pk, qty: 0 };
      lines[pk.id].qty++;
      cur = pick[cur].prev;
    }
    var arr = Object.keys(lines).map(function (k) { return lines[k]; });
    arr.sort(function (a, b) { return b.variant.m - a.variant.m; });
    return { cost: cost[bestL], metres: bestL, lines: arr };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { pack: pack, cheapestMetres: cheapestMetres, altoUsado: altoUsado };
    return;
  }

  /* ---------- Utilidades ---------- */
  function $(root, sel) { return root.querySelector(sel); }
  function money(cents) { return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Cómo se llama cada arreglo. El catálogo vive en archivo.js, en un solo
     sitio para las cinco fichas: así añadir un arreglo nuevo no obliga a
     acordarse de cinco ficheros. Si por lo que sea no está cargado, se cae a un
     literal antes que dejar un botón sin texto. */
  var NOMBRES = {
    fondo: 'Quitar el fondo', bordes: 'Afinar los bordes',
    negro: 'El fondo negro es la prenda'
  };
  function rotulo(t) {
    return (window.Archivo && Archivo.boton) ? Archivo.boton(t) : (NOMBRES[t] || t);
  }
  // lo que lee Xavi en el pedido, que a veces es una INSTRUCCIÓN de producción
  function pedido(t) {
    return (window.Archivo && Archivo.pedido) ? Archivo.pedido(t) : (NOMBRES[t] || t);
  }

  /* Los ppp con que el diseño dice haberse hecho (bloque pHYs del PNG), o 0 si no los trae.
     72 y 96 son lo que ponen por defecto muchos programas al exportar para pantalla: no
     dicen nada del tamaño de impresión, así que se tratan como «sin dato» (y se entra a 300 ppp). */
  async function pngPpp(file) {
    try {
      var b = new Uint8Array(await file.slice(0, 4096).arrayBuffer()), dv = new DataView(b.buffer), i = 8;
      while (i + 12 <= b.length) {
        var len = dv.getUint32(i), tipo = String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);
        if (tipo === 'IDAT') return 0;
        if (tipo === 'pHYs' && b[i + 16] === 1) {
          var ppp = dv.getUint32(i + 8) * 0.0254;
          return (Math.abs(ppp - 72) < 1.5 || Math.abs(ppp - 96) < 1.5) ? 0 : ppp;
        }
        i += 12 + len;
      }
    } catch (e) { /* sin dato */ }
    return 0;
  }

  async function analyse(file, fondoSeImprime) {
    var bmp = await createImageBitmap(file);
    var W = bmp.width, H = bmp.height;
    // se analiza a un máximo de ~16 Mpx para no bloquear el móvil
    var scale = Math.min(1, Math.sqrt(16e6 / (W * H)));
    var cw = Math.max(1, Math.round(W * scale)), ch = Math.max(1, Math.round(H * scale));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(bmp, 0, 0, cw, ch);
    var d = ctx.getImageData(0, 0, cw, ch).data;
    var minX = cw, minY = ch, maxX = -1, maxY = -1, transparent = false;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        var a = d[(y * cw + x) * 4 + 3];
        if (a < 250) transparent = true;
        if (a >= 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
      }
    }
    if (maxX < 0) { if (bmp.close) bmp.close(); throw new Error('la imagen está vacía (todo transparente).'); }
    /* Margen liso fuera (Xavi, 26/09), igual que en la ficha de transfers:
       se mide y se monta solo lo que hay dentro. En UV no, que ahí el fondo
       se imprime y el margen puede ser parte del diseño. */
    var pre = { x: minX, y: minY, X: maxX, Y: maxY }, margen = false;
    if (!transparent && !fondoSeImprime && window.ImgArreglo && ImgArreglo.margenLiso) {
      var mg = ImgArreglo.margenLiso(d, cw, ch);
      if (mg) { minX = mg.x; minY = mg.y; maxX = mg.X; maxY = mg.Y; margen = true; }
    }
    var crop = {
      x: Math.max(0, Math.floor(minX / scale)), y: Math.max(0, Math.floor(minY / scale)),
      x2: Math.min(W, Math.ceil((maxX + 1) / scale)), y2: Math.min(H, Math.ceil((maxY + 1) / scale))
    };
    crop.w = crop.x2 - crop.x; crop.h = crop.y2 - crop.y;
    var t = Math.min(1, 600 / Math.max(crop.w, crop.h));
    var th = document.createElement('canvas');
    th.width = Math.max(1, Math.round(crop.w * t)); th.height = Math.max(1, Math.round(crop.h * t));
    th.getContext('2d').drawImage(bmp, crop.x, crop.y, crop.w, crop.h, 0, 0, th.width, th.height);
    // las sondas del fondo miran el archivo con su margen, que es lo que tienen que ver
    var tp = th;
    if (margen) {
      var px0 = Math.floor(pre.x / scale), py0 = Math.floor(pre.y / scale);
      var pw = Math.min(W, Math.ceil((pre.X + 1) / scale)) - px0, ph = Math.min(H, Math.ceil((pre.Y + 1) / scale)) - py0;
      var tt = Math.min(1, 600 / Math.max(pw, ph));
      tp = document.createElement('canvas');
      tp.width = Math.max(1, Math.round(pw * tt)); tp.height = Math.max(1, Math.round(ph * tt));
      tp.getContext('2d').drawImage(bmp, px0, py0, pw, ph, 0, 0, tp.width, tp.height);
    }
    if (bmp.close) bmp.close();
    return {
      pxW: W, pxH: H, crop: crop, transparent: transparent, thumb: th,
      /* ¿el diseño viene sobre un rectángulo negro? En un transfer eso importa
         más que en ninguna otra ficha: ese negro no es dibujo, es la prenda, y
         si se imprime sale un parche negro sobre la camiseta. */
      sobreNegro: !!(window.ImgArreglo && ImgArreglo.pideFundirNegro(tp)),
      /* ¿el marco es CLARO? Decide si se ofrece «Eliminar blanco de fondo».
         Un PNG sin transparencia sobre blanco es de lo más normal que llega. */
      fondoClaro: fondoClaroDe(tp, transparent),
      /* ¿cuánto del diseño es negro o casi, aunque no haga recuadro? Una
         portada de disco trae el negro levantado y repartido: sin esto no
         se le ofrecía «Eliminar negro de fondo» (Xavi, 26/09). */
      parteOscura: (window.ImgArreglo && ImgArreglo.parteOscura) ? ImgArreglo.parteOscura(th) : 0,
      // ¿una foto de la prenda con el diseño puesto? (ChatGPT) — se mira con su margen
      mockup: (function () {
        try { var mk = window.ImgArreglo && ImgArreglo.pareceMockup && ImgArreglo.pareceMockup(tp, file.name); return !!(mk && mk.mockup); }
        catch (e) { return false; }
      })()
    };
  }

  function fondoClaroDe(th, transparente) {
    if (transparente || !window.ImgArreglo || !ImgArreglo.colorBorde) return false;
    try {
      var cb = ImgArreglo.colorBorde(th);
      return !!(cb && cb.parte >= 0.3 && Math.min(cb.r, cb.g, cb.b) >= 200);
    } catch (e) { return false; }
  }

  /* LA TOLERANCIA DEL RECORTE, igual que en la ficha de transfers. Cada paso
     multiplica por 1,35 y relaja lo que se exige al marco para darlo por
     fondo; se recorta SIEMPRE desde el original, nunca encima de lo ya
     recortado. Ver subida-dtf.js. */
  var PASO_TOL = 1.35, TOL_MIN = -2, TOL_MAX = 5;
  function tolerancia(nivel) {
    var k = Math.pow(PASO_TOL, nivel || 0);
    return { t1: 62 * k, t2: 132 * k, minParte: Math.min(0.55, 0.55 / k) };
  }

  /* ---------- Quitar fondo o colores: tolerancia y varita ----------
     Lo mismo que en el editor: una barra de tolerancia, «solo el fondo» (relleno
     desde los bordes) o «todo ese color», y una varita para tocar en el diseño
     otros colores que quitar (con sus fichas para volver a ponerlos). Se calcula
     en una previa pequeña y, al aplicar, otra vez a tamaño completo. */
  function qfQuitarDesde(c, x0, y0, col, t1, t2) {
    var ctx = c.getContext('2d'), d = ctx.getImageData(0, 0, c.width, c.height), p = d.data, w = d.width, h = d.height, n = w * h;
    var visto = new Uint8Array(n), pila = new Int32Array(n), tope = 0, borrados = 0;
    function dist(i) { var dr = p[i * 4] - col.r, dg = p[i * 4 + 1] - col.g, db = p[i * 4 + 2] - col.b; return Math.sqrt(dr * dr + dg * dg + db * db); }
    function empuja(i) { if (visto[i] || p[i * 4 + 3] < 8 || dist(i) > t2) return; visto[i] = 1; pila[tope++] = i; }
    empuja(y0 * w + x0);
    while (tope > 0) {
      var i = pila[--tope], dd = dist(i), a = p[i * 4 + 3];
      if (dd <= t1) { p[i * 4 + 3] = 0; borrados++; }
      else { p[i * 4 + 3] = Math.round(a * Math.min(1, (dd - t1) / (t2 - t1))); continue; }
      var xi = i % w, yi = (i - xi) / w;
      if (xi > 0) empuja(i - 1); if (xi < w - 1) empuja(i + 1); if (yi > 0) empuja(i - w); if (yi < h - 1) empuja(i + w);
    }
    ctx.putImageData(d, 0, 0);
    return borrados;
  }
  function qfColorGlobal(c, b, t1, t2) {
    var ctx = c.getContext('2d'), d = ctx.getImageData(0, 0, c.width, c.height), p = d.data, n = 0;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 8) continue;
      var dr = p[i] - b.r, dg = p[i + 1] - b.g, db = p[i + 2] - b.b, dd = Math.sqrt(dr * dr + dg * dg + db * db);
      if (dd <= t1) { p[i + 3] = 0; n++; }
      else if (dd < t2) p[i + 3] = Math.round(p[i + 3] * (dd - t1) / (t2 - t1));
    }
    ctx.putImageData(d, 0, 0);
    return { ok: n > 0, lienzo: c };
  }
  function qfCopia(c) {
    var k = document.createElement('canvas'); k.width = c.width; k.height = c.height;
    k.getContext('2d', { willReadFrequently: true }).drawImage(c, 0, 0);
    return k;
  }
  function qfConMargen(c, b) {
    var mg = Math.round(Math.max(c.width, c.height) * 0.12) + 4;
    var cm = document.createElement('canvas'); cm.width = c.width + 2 * mg; cm.height = c.height + 2 * mg;
    var cx = cm.getContext('2d');
    cx.fillStyle = b ? 'rgb(' + Math.round(b.r) + ',' + Math.round(b.g) + ',' + Math.round(b.b) + ')' : '#fff';
    cx.fillRect(0, 0, cm.width, cm.height); cx.drawImage(c, mg, mg);
    return cm;
  }
  function qfSinMargen(cm, w, h) {
    var mg = Math.round((cm.width - w) / 2);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    c.getContext('2d').drawImage(cm, -mg, -mg);
    return c;
  }
  // el resultado de quitar fondo y colores sobre `base` con lo que diga `qf`: { ok, lienzo, motivo }
  function qfCalcular(base, qf) {
    var t = qf.tol, t1 = 12 + t * 1.28, t2 = t1 + 60, todo = qf.modo === 'todo';
    var c = qfCopia(base), res = null;
    try {
      var b = ImgArreglo.colorBorde ? ImgArreglo.colorBorde(c) : { r: 255, g: 255, b: 255 };
      if (todo) res = qfColorGlobal(c, b, t1, t2);
      else if (ImgArreglo.quitarFondo) {
        res = ImgArreglo.quitarFondo(qfConMargen(c, b), { t1: t1, t2: t2, minParte: 0.2 });
        res = (res && res.ok) ? { ok: true, lienzo: qfSinMargen(res.lienzo, c.width, c.height) } : { ok: false, motivo: res && res.motivo };
      }
      if (qf.colores.length) {
        var lz = (res && res.ok) ? res.lienzo : c, n = 0;
        qf.colores.forEach(function (col) {
          var x = Math.min(lz.width - 1, Math.max(0, Math.round(col.fx * (lz.width - 1)))), y = Math.min(lz.height - 1, Math.max(0, Math.round(col.fy * (lz.height - 1))));
          n += todo ? (qfColorGlobal(lz, col, t1, t2).ok ? 1 : 0) : qfQuitarDesde(lz, x, y, col, t1, t2);
        });
        if (n) res = { ok: true, lienzo: lz };
      }
    } catch (e) { res = { ok: false }; }
    return res || { ok: false };
  }

  /* ---------- Montador ---------- */
  function Montador(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-montador-config]').textContent);
    this.logos = []; this.result = null; this.choice = null; this.userChoice = false;
    this.sheetIdx = 0; this.seq = 0; this.busy = false;
    this.bind(); this.renderList(); this.renderResult();
  }

  Montador.prototype.bind = function () {
    var self = this, r = this.root;
    var input = $(r, '[data-file-input]'), drop = $(r, '[data-drop]');
    input.addEventListener('change', function () { self.addFiles(Array.prototype.slice.call(input.files)); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { self.addFiles(Array.prototype.slice.call(e.dataTransfer.files)); });
    var list = $(r, '[data-list]');
    list.addEventListener('input', function (e) {
      var row = e.target.closest('[data-id]'); if (!row) return;
      var logo = self.byId(row.dataset.id); if (!logo) return;
      if (e.target.name === 'w') logo.wCm = parseFloat(String(e.target.value).replace(',', '.')) || 0;
      if (e.target.name === 'q') logo.qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      if (e.target.name === 'qf-tol' && logo.qf) { logo.qf.tol = parseInt(e.target.value, 10) || 0; var tv = row.querySelector('[data-qf-tolv]'); if (tv) tv.textContent = logo.qf.tol; self.previaQF(logo); return; }
      self.updateRow(logo); self.schedule();
    });
    // al pulsar en ancho o cantidad se vacía para escribir de cero (sobre todo en el móvil);
    // si se sale sin escribir nada, vuelve el valor que tenía
    // las flechas de más/menos (borde derecho del campo) NO lo vacían: se pulsa para subir o bajar
    var enFlechas = false;
    list.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input[name="w"], input[name="q"]')) { enFlechas = false; return; }
      var r = t.getBoundingClientRect();
      enFlechas = t.type === 'number' && e.pointerType === 'mouse' && e.clientX > r.right - 24;
    }, true);
    list.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input[name="w"], input[name="q"]')) return;
      if (enFlechas) { enFlechas = false; return; }
      t.dataset.previo = t.value; t.value = '';
    });
    list.addEventListener('focusout', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input[name="w"], input[name="q"]')) return;
      if (t.value === '' && t.dataset.previo) {
        t.value = t.dataset.previo; t.dispatchEvent(new Event('input', { bubbles: true }));
      }
      delete t.dataset.previo;
    });
    list.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[data-qf-modo]')) return;
      var lg = self.byId(e.target.closest('[data-id]').dataset.id);
      if (lg && lg.qf) { lg.qf.modo = e.target.value; self.previaQF(lg); }
    });
    list.addEventListener('click', function (e) {
      var pb = e.target.closest('[data-paso]');
      if (pb) {
        var campo = pb.parentNode.querySelector('input'), nv = Math.max(0, (parseInt(campo.value, 10) || 0) + parseInt(pb.dataset.paso, 10));
        campo.value = nv; campo.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
      var fila = e.target.closest('[data-id]'); if (!fila) return;
      var logo = self.byId(fila.dataset.id); if (!logo) return;
      if (e.target.closest('[data-remove]')) {
        self.logos = self.logos.filter(function (l) { return l !== logo; });
        self.renderList(); self.schedule();
        return;
      }
      var cerrada = fila.classList.contains('is-cerrado');
      if (e.target.closest('[data-plegar], .mdtf-logo__name') || (cerrada && !e.target.closest('input, label, [data-remove]'))) {
        if (logo.loading || logo.qf) return;
        self.plegarFila(logo, !logo.abierto);
        return;
      }
      var qa = e.target.closest('[data-qf-act]');
      if (qa) { self.accionQF(logo, qa.dataset.qfAct, qa); return; }
      var acc = e.target.closest('[data-act]'); if (!acc) return;
      var tipo = acc.dataset.act;
      if (tipo === 'ajustar') {
        logo.wCm = Math.floor(self.anchoNitido(logo) * 10) / 10;
        var campo = fila.querySelector('input[name="w"]');
        if (campo) campo.value = logo.wCm;
        self.updateRow(logo); self.schedule();
      } else if (tipo === 'qf') {
        self.abrirQF(logo);
      } else if (tipo === 'deshacer') {
        self.deshacer(logo);
      } else if (tipo === 'tol-mas' || tipo === 'tol-menos') {
        self.ajustarFondo(logo, tipo === 'tol-mas' ? 1 : -1);
      } else {
        self.arreglar(logo, tipo);
      }
    });
    // distancia entre diseños: 3, 4 (la de siempre) o 5 mm; al cambiarla se vuelve a montar
    var selGap = $(r, '[data-gap]');
    this.gap = Math.min(5, Math.max(3, Math.round(this.cfg.gap) || 4));
    if (selGap) {
      selGap.value = String(this.gap);
      selGap.addEventListener('change', function () { self.gap = parseInt(selGap.value, 10) || 4; self.userChoice = false; self.schedule(); });
    }
    // picar fuera del diseño abierto lo pliega (menos si tiene el Borrador abierto)
    document.addEventListener('click', function (e) {
      var fila = e.target.closest && e.target.closest('.mdtf-logo');
      if (e.target.closest && e.target.closest('.mdtf-flash, .crg-aviso')) return;
      self.logos.forEach(function (o) {
        if (o.abierto && !o.qf && !o.loading && !(fila && fila.dataset.id === o.id)) self.plegarFila(o, false);
      });
    });
    $(r, '[data-options]').addEventListener('change', function (e) {
      if (e.target.name !== 'formato') return;
      self.choice = e.target.value; self.userChoice = true; self.sheetIdx = 0; self.renderResult();
    });
    $(r, '[data-prev]').addEventListener('click', function () { self.sheetIdx--; self.drawPreview(); });
    $(r, '[data-next]').addEventListener('click', function () { self.sheetIdx++; self.drawPreview(); });
    $(r, '[data-accept]').addEventListener('change', function () { self.updateButton(); });
    $(r, '[data-add]').addEventListener('click', function () { self.addToCart(); });
    var bPres = $(r, '[data-presupuesto]');
    if (bPres) bPres.addEventListener('click', function () { self.addToCart(true); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { self.drawPreview(); }, 150); });
  };

  // abrir o plegar la fila de un diseño sin rehacer la lista
  Montador.prototype.plegarFila = function (l, abrir) {
    l.abierto = !!abrir;
    var fila = this.root.querySelector('[data-id="' + l.id + '"]');
    if (!fila) return;
    fila.classList.toggle('is-cerrado', !l.abierto);
    var bp = fila.querySelector('[data-plegar]');
    if (bp) { bp.textContent = l.abierto ? '▴' : '▾'; bp.setAttribute('aria-expanded', l.abierto ? 'true' : 'false'); }
  };

  Montador.prototype.byId = function (id) { return this.logos.filter(function (l) { return l.id === id; })[0]; };

  Montador.prototype.addFiles = async function (files) {
    var cfg = this.cfg;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      if (this.logos.length >= cfg.maxLogos) { this.flash('Máximo ' + cfg.maxLogos + ' diseños por montaje.'); break; }
      if (!/png$/i.test(f.type) && !/\.png$/i.test(f.name)) { this.flash(f.name + ': solo se admiten archivos PNG.'); continue; }
      if (f.size > cfg.maxFileMb * 1048576) { this.flash(f.name + ': pesa más de ' + cfg.maxFileMb + ' MB.'); continue; }
      var logo = { id: 'l' + (++this.seq), file: f, name: f.name, wCm: cfg.defaultWidthCm, qty: 1, loading: true, _montador: this };
      this.logos.push(logo); this.renderList();
      // deja pintar el esqueleto antes de bloquear el hilo leyendo los píxeles
      if (window.Cargando) await Cargando.pinta();
      try {
        Object.assign(logo, await analyse(f, cfg.fondoSeImprime));
        logo.loading = false;
        // el nuevo se enseña abierto para ajustarlo; los que ya estaban colocados se pliegan a una línea
        this.logos.forEach(function (o) { if (o !== logo && !o.qf) o.abierto = false; });
        logo.abierto = true;
        // el diseño entra a su tamaño: el que dice el archivo (p. ej. 40 × 50 cm) o, si no dice nada, a 300 ppp
        var ppp = (await pngPpp(f)) || 300;
        if (ppp) logo.wCm = Math.max(1, Math.round((logo.cropCalidad || logo.crop).w / ppp * 2.54 * 10) / 10);
        var maxW = this.maxWidthCm(logo);
        if (logo.wCm > maxW) logo.wCm = Math.floor(maxW * 10) / 10;
      } catch (err) {
        this.logos = this.logos.filter(function (l) { return l !== logo; });
        this.flash(f.name + ': ' + (err && err.message ? err.message : 'no se ha podido leer.'));
      }
      this.renderList(); this.schedule();
    }
  };

  // ancho máximo (cm) para que el diseño quepa en el formato más grande disponible, girando si hace falta
  Montador.prototype.maxWidthCm = function (logo) {
    var ar = logo.crop.h / logo.crop.w, best = 0;
    this.formats().forEach(function (f) {
      best = Math.max(best, Math.min(f.w, f.h / ar), Math.min(f.h, f.w / ar));
    });
    return best / 10;
  };
  Montador.prototype.formats = function () {
    var c = this.cfg, out = [];
    if (c.hoja.variant) out.push(c.hoja);
    if (c.metro.packs.length) out.push(c.metro);
    return out;
  };

  Montador.prototype.dims = function (logo) {
    var w = logo.wCm * 10;
    // ojo: para los ppp se usan los píxeles ORIGINALES. Afinar amplía el archivo
    // pero no añade detalle, así que la calidad no puede subir por eso.
    var px = (logo.cropCalidad || logo.crop).w;
    return { w: w, h: w * logo.crop.h / logo.crop.w, dpi: px / (logo.wCm / 2.54) };
  };

  // ancho (cm) al que ese archivo se ve nítido
  Montador.prototype.anchoNitido = function (logo) {
    return (logo.cropCalidad || logo.crop).w / (this.cfg.dpiGood / 2.54);
  };

  Montador.prototype.quality = function (dpi) {
    if (dpi >= this.cfg.dpiGood) return { k: 'ok', t: 'Buena calidad' };
    if (dpi >= this.cfg.dpiMin) return { k: 'mid', t: 'Calidad justa' };
    return { k: 'low', t: 'Resolución baja: puede verse pixelado' };
  };

  Montador.prototype.renderList = function () {
    var self = this, list = $(this.root, '[data-list]');
    list.innerHTML = this.logos.map(function (l) {
      var cerrado = !l.loading && !l.abierto && !l.qf;
      return '<li class="mdtf-logo' + (cerrado ? ' is-cerrado' : '') + '" data-id="' + l.id + '">' +
        '<div class="mdtf-logo__thumb' + (l.loading ? ' crg-esq' : '') + '" data-thumb></div>' +
        '<div class="mdtf-logo__body">' +
          '<p class="mdtf-logo__name">' + esc(l.name) + '</p>' +
          (l.loading ? '<p class="mdtf-muted" role="status"><span class="crg-rueda" aria-hidden="true"></span> Analizando el diseño…</p>' :
          '<div class="mdtf-logo__fields">' +
            '<label>Ancho (cm)<input type="number" name="w" min="1" step="0.1" inputmode="decimal" value="' + l.wCm + '"></label>' +
            '<label>Copias<span class="mdtf-step"><button type="button" data-paso="-1" aria-label="Menos copias">−</button><input type="number" name="q" min="0" step="1" inputmode="numeric" value="' + l.qty + '"><button type="button" data-paso="1" aria-label="Más copias">+</button></span></label>' +
          '</div><p class="mdtf-logo__info" data-info></p>') +
        '</div>' +
        (l.loading ? '' : '<span class="mdtf-logo__estado" data-estado></span>' +
          '<button type="button" class="mdtf-logo__plegar" data-plegar aria-label="Ver u ocultar los ajustes de este diseño" aria-expanded="' + (cerrado ? 'false' : 'true') + '">' + (cerrado ? '▾' : '▴') + '</button>') +
        '<button type="button" class="mdtf-logo__remove" data-remove aria-label="Quitar ' + esc(l.name) + '">×</button>' +
        /* LOS ARREGLOS VAN A LO ANCHO DE TODA LA FILA, no en la columna del
           texto. Metidos ahí, en un móvil se quedaban en 200 px entre la
           miniatura y la cruz: el texto palabra a palabra y los botones uno
           debajo de otro. Xavi: «en móvil queda pequeño». */
        (l.loading ? '' : '<div class="mdtf-fix" data-fixes hidden></div><div class="mdtf-qf" data-qf hidden></div>') +
      '</li>';
    }).join('');
    this.logos.forEach(function (l) {
      if (l.loading) return;
      list.querySelector('[data-id="' + l.id + '"] [data-thumb]').appendChild(l.thumb);
      self.updateRow(l);
      if (l.qf) self.pintarQF(l);
    });
    $(this.root, '[data-empty]').hidden = this.logos.length > 0;
    var sepW = $(this.root, '[data-sep-wrap]'); if (sepW) sepW.hidden = !this.logos.length;
  };

  Montador.prototype.updateRow = function (l) {
    if (l.loading) return;
    var info = this.root.querySelector('[data-id="' + l.id + '"] [data-info]'); if (!info) return;
    var d = this.dims(l), q = this.quality(d.dpi), maxW = this.maxWidthCm(l), parts = [];
    if (!(l.wCm > 0)) parts.push('<span class="mdtf-badge mdtf-badge--low">Indica el ancho</span>');
    else if (l.wCm > maxW + 0.001) parts.push('<span class="mdtf-badge mdtf-badge--low">Máximo ' + fmt(Math.floor(maxW * 10) / 10, 1) + ' cm de ancho</span>');
    else {
      parts.push('Medida final ' + fmt(d.w / 10, 1) + ' × ' + fmt(d.h / 10, 1) + ' cm');
      parts.push('<span class="mdtf-badge mdtf-badge--' + q.k + '">' + q.t + ' · ' + Math.round(d.dpi) + ' ppp</span>');
      // por qué se va a rollo: a ese ancho no cabe en la hoja y se dice hasta dónde sí cabe
      var hj = this.cfg.hoja;
      if (hj && hj.variant && !((d.w <= hj.w + 0.5 && d.h <= hj.h + 0.5) || (d.h <= hj.w + 0.5 && d.w <= hj.h + 0.5))) {
        var ar = l.crop.h / l.crop.w, enHoja = Math.max(Math.min(hj.w, hj.h / ar), Math.min(hj.h, hj.w / ar)) / 10;
        parts.push('<span class="mdtf-badge mdtf-badge--mid">No cabe en la hoja de 40×50 (mide ' + fmt(d.w / 10, 1) + ' × ' + fmt(d.h / 10, 1) +
          ' cm). Para que entre en hoja: hasta ' + fmt(Math.floor(enHoja * 10) / 10, 1) + ' cm de ancho</span>');
      }
    }
    if (!l.transparent) parts.push('<span class="mdtf-badge mdtf-badge--mid">Sin fondo transparente: el fondo también se imprime</span>');
    info.innerHTML = parts.join(' ');
    // el aviso corto de la fila plegada: solo si hay algo que mirar
    var est = this.root.querySelector('[data-id="' + l.id + '"] [data-estado]');
    if (est) {
      var aviso = !(l.wCm > 0) ? 'Indica el ancho' : l.wCm > maxW + 0.001 ? 'Demasiado ancho'
        : d.dpi < this.cfg.dpiMin ? 'Resolución baja' : !l.transparent ? 'Con fondo' : '';
      est.textContent = aviso ? '⚠ ' + aviso : '';
      est.title = aviso ? 'Abre el diseño para ver el detalle y arreglarlo' : '';
    }
    this.updateFixes(l);
  };

  /* ---------- arreglos por diseño ----------
     Aquí, además de quitar el fondo y afinar los bordes, hay una salida que en
     las fichas normales no existe: bajar el ancho hasta donde el archivo se ve
     nítido. Es la solución honesta, y es gratis. */
  Montador.prototype.updateFixes = function (l) {
    var caja = this.root.querySelector('[data-id="' + l.id + '"] [data-fixes]');
    if (!caja) return;
    if (!window.ImgArreglo || !(l.wCm > 0)) { caja.hidden = true; return; }

    var d = this.dims(l), hechos = l.arreglos || [], btns = [], nota = '';
    var nit = Math.floor(this.anchoNitido(l) * 10) / 10;

    if (d.dpi < this.cfg.dpiGood && nit >= 2 && nit < l.wCm - 0.3) {
      btns.push('<button type="button" class="mdtf-fix__b" data-act="ajustar">Ajustar a ' + fmt(nit, 1) + ' cm</button>');
    }
    /* NO SE AFINA LO QUE YA LLEVA SEMITONO (Xavi, 26/09). Afinar endurece la
       transparencia con una curva en S: en un logo limpia el contorno, pero
       tras fundir el negro la transparencia ES el degradado que el taller
       trama, y la curva se lo come — sombras fuera, grises macizos. */
    if (d.dpi < this.cfg.dpiMin && hechos.indexOf('bordes') === -1 && hechos.indexOf('negro') === -1 &&
        (l.cropCalidad || l.crop).w <= 1800) {
      btns.push('<button type="button" class="mdtf-fix__b" data-act="bordes">' + rotulo('bordes') + '</button>');
    }
    /* Si el diseño viene sobre un rectángulo negro, lo que toca es FUNDIR ese
       negro con la prenda, no recortarlo: recortar un fondo plano deja un borde
       duro justo donde el dibujo se estaba apagando. Así que se ofrece uno o el
       otro, nunca los dos.

       Y solo donde el fondo NO se imprime. En UV DTF el negro es tinta que va a
       acabar pegada a una taza o a un casco: quitarlo sería estropearle el
       diseño, igual que en tarjetas y pegatinas. */
    /* Xavi, 26/09: el semitono se vende como ventaja y se ofrece «siempre
       sobre el negro»; el cliente lo ve ampliado y, si no le gusta, lo
       deshace. Aquí no se sabe la tela, así que se enseña sobre negro. */
    var negroDentro = !l.sobreNegro && (l.parteOscura || 0) >= 0.05;
    var negro = !this.cfg.fondoSeImprime && (l.sobreNegro || negroDentro) && hechos.indexOf('negro') === -1;
    /* FUERA EL QUITAFONDOS GENÉRICO, IGUAL QUE EN TRANSFERS. Xavi, 26/09:
       «casi siempre se deja algún trozo sin quitar». Queda el de negro y, solo
       cuando el marco es claro, «Eliminar blanco de fondo» con su −/+ debajo
       para que el cliente apriete hasta que salga limpio. */
    // si el automático ya falló, el paso siguiente es el «Quitar más», no repetir
    var blanco = !(negro && l.sobreNegro) && !l.transparent && l.fondoClaro && hechos.indexOf('fondo') === -1 &&
      !l.fondoFallido;
    if (negro) {
      btns.push('<button type="button" class="mdtf-fix__b" data-act="negro">' + rotulo('negro') + '</button>');
    }
    if (l.anterior) btns.push('<button type="button" class="mdtf-fix__b mdtf-fix__b--gris" data-act="deshacer">Deshacer</button>');

    // el panel de tolerancia y varita: para lo que no es transparente, o para retocar un fondo ya recortado
    var recortado = hechos[hechos.length - 1] === 'fondo' || !!l.fondoFallido;
    var tolHtml = '';
    if (!l.qf && !(negro && l.sobreNegro) && (!l.transparent || recortado)) {
      btns.push('<button type="button" class="mdtf-fix__b" data-act="qf">🧽 Borrador · fondo y colores</button>');
    }

    if (l.mockup && !hechos.length) {
      nota = '<b>Parece una foto de la prenda con el diseño puesto.</b> Así se imprimiría la foto ' +
        'entera, con la tela y el fondo. Necesitamos solo el dibujo. Si lo has hecho con ChatGPT, ' +
        'pídele: «dame solo el diseño, sin la camiseta, en PNG con fondo transparente», y súbelo aquí.';
    } else if (negro && negroDentro) {
      nota = '<b>El semitono es solo si va sobre prenda negra</b> (u oscura). Así tu diseño queda más ligero, ' +
        'más suave al tacto, transpira mejor y no hace parche. Sobre prenda clara no lo uses: déjalo como está.';
    } else if (negro) {
      nota = 'Tu diseño viene sobre un <b>fondo negro</b>. En un transfer ese negro ' +
        'no es dibujo: es la tela donde lo pegues. Si lo quitamos se imprime la mitad ' +
        'de tinta, la tela transpira y el dibujo se funde con ella en vez de acabar en ' +
        'un parche negro.';
    } else if (hechos.length) {
      var ultimo = hechos[hechos.length - 1];
      nota = '<b>Listo.</b> ' + (ultimo === 'negro' ? 'Con semitono: más ligero, más suave y transpira mejor. Aquí abajo ves cómo queda de cerca.'
        : ultimo === 'fondo' ? 'Fondo quitado.'
        : 'Ampliado y bordes limpios. La nota de calidad no sube, y es a propósito: ampliar no añade detalle. Lo que mejora es que no se vean los dientes de sierra.');
    } else if (d.dpi < this.cfg.dpiMin) {
      nota = 'A ' + fmt(l.wCm, 1) + ' cm se va a notar. Este archivo se ve nítido hasta <b>' + fmt(nit, 1) + ' cm</b>.';
    }

    caja.innerHTML = (nota ? '<p class="mdtf-fix__t">' + nota + '</p>' : '') +
      (btns.length ? '<div class="mdtf-fix__btns">' + btns.join('') + '</div>' : '') + tolHtml +
      '<div class="mdtf-compara" data-compara hidden>' +
        '<figure><figcaption>Antes</figcaption><div class="mdtf-compara__img" data-antes></div></figure>' +
        '<figure><figcaption>Ahora</figcaption><div class="mdtf-compara__img" data-ahora></div></figure>' +
        '<p class="mdtf-compara__nota">Es una zona ampliada de lo que ha cambiado. Se imprime el archivo entero.</p>' +
      '</div>';
    caja.hidden = !(nota || btns.length || tolHtml);
    // si ha cambiado el ancho, la vista del semitono se rehace a la nueva escala
    var cv = l.comparativa;
    if (cv && cv.semitono && l.wCm && Math.abs(l.wCm * 10 - cv.mm) > 0.5) {
      try { l.comparativa = ImgArreglo.vistaSemitono(cv.origen, cv.resultado, l.wCm * 10, cv.w, cv.h, cv.tramaMm); }
      catch (e) { /* se queda la de antes */ }
    }
    if (l.comparativa) {
      var comp = caja.querySelector('[data-compara]');
      comp.hidden = false;
      comp.querySelector('[data-antes]').appendChild(l.comparativa.antes);
      comp.querySelector('[data-ahora]').appendChild(l.comparativa.despues);
      if (l.comparativa.semitono) {
        comp.querySelector('[data-ahora]').style.background = '#111';
        var caps = comp.querySelectorAll('figcaption');
        caps[0].textContent = 'Tal cual'; caps[1].textContent = 'Con semitono';
        comp.querySelector('.mdtf-compara__nota').textContent =
          'Así se verá de cerca sobre tela negra.';
      }
    }
  };

  /* Subir o bajar la tolerancia: se vuelve al archivo de antes del recorte
     y se recorta otra vez desde él. */
  Montador.prototype.ajustarFondo = function (l, delta) {
    if (this.ocupado) return;
    var nivel = Math.max(TOL_MIN, Math.min(TOL_MAX, (l.tolFondo || 0) + delta));
    if (nivel === (l.tolFondo || 0)) return;
    var hechos = l.arreglos || [];
    if (hechos[hechos.length - 1] === 'fondo' && l.anterior) this.deshacer(l, true);
    this.arreglar(l, 'fondo', nivel);
  };

  Montador.prototype.arreglar = async function (l, tipo, nivel) {
    if (!window.ImgArreglo || this.ocupado) return;
    this.ocupado = true;
    var b = this.root.querySelector('[data-id="' + l.id + '"] [data-act="' + tipo + '"]');
    if (window.Cargando) {
      Cargando.ocupar(b, tipo === 'fondo' ? 'Quitando el fondo…'
        : tipo === 'negro' ? 'Fundiendo el negro…' : 'Afinando…');
      await Cargando.pinta();
    } else if (b) { b.disabled = true; b.textContent = 'Un momento…'; }
    try {
      var bmp = await createImageBitmap(l.file);
      var orig = document.createElement('canvas');
      orig.width = bmp.width; orig.height = bmp.height;
      orig.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      var res = tipo === 'fondo' ? ImgArreglo.quitarFondo(orig, tolerancia(nivel))
        : tipo === 'negro' ? ImgArreglo.fundirNegro(orig)
        : ImgArreglo.afinarBordes(orig, 3);
      if (!res.ok) {
        this.ocupado = false;
        /* Blanco con degradado o viñeta: el automático no lo ve como fondo,
           pero el cliente sí. Se le deja el «Quitar más» a mano. */
        if (tipo === 'fondo' && res.motivo === 'sin-fondo') {
          l.fondoFallido = true; l.tolFondo = nivel || 0;
          this.updateRow(l);
          return this.flash(l.name + (nivel
            ? ': con esa tolerancia tampoco lo vemos como fondo. Sube otro punto.'
            : ': no vemos un fondo liso. Si lo tiene (blanco con sombra, degradado…), dale a «Quitar más».'));
        }
        this.updateRow(l);
        return this.flash(tipo === 'fondo'
          ? l.name + ': no hemos encontrado un fondo liso que quitar.'
          : tipo === 'negro'
          ? l.name + ': no hay bastante negro que fundir con la prenda.'
          : l.name + ': ya tiene tamaño de sobra, no hace falta afinarlo.');
      }
      var base = l.name.replace(/\.[^.]+$/, '');
      var sufijo = tipo === 'fondo' ? '-sin-fondo' : tipo === 'negro' ? '-sin-negro' : '-afinado';
      var nuevo = await ImgArreglo.aFichero(res.lienzo, base + sufijo + '.png');
      if (nuevo.size > this.cfg.maxFileMb * 1048576) {
        this.ocupado = false; this.updateRow(l);
        return this.flash('El archivo arreglado pesa más de ' + this.cfg.maxFileMb + ' MB. Se queda como estaba.');
      }
      var comp = null;
      try {
        if (tipo === 'negro' && ImgArreglo.vistaSemitono) {
          // el semitono, a escala de su ancho, sobre negro
          comp = ImgArreglo.vistaSemitono(orig, res.lienzo, (l.wCm || 10) * 10, 440, 300, this.cfg.tramaMm);
        } else {
          comp = ImgArreglo.comparar(orig, res.lienzo, 440, 300);
        }
      } catch (e) { comp = null; }

      /* Ojo con esta lista: es a mano, así que TODA marca nueva del diseño tiene
         que añadirse aquí y en deshacer(). Con `sobreNegro` ya pasó en la ficha
         de ropa — se quedó fuera, al deshacer se perdía y el botón del fondo
         negro no volvía a salir. */
      var anterior = {
        file: l.file, name: l.name, pxW: l.pxW, pxH: l.pxH, crop: l.crop,
        transparent: l.transparent, thumb: l.thumb, cropCalidad: l.cropCalidad,
        sobreNegro: l.sobreNegro, fondoClaro: l.fondoClaro, parteOscura: l.parteOscura, mockup: l.mockup,
        arreglos: (l.arreglos || []).slice(), comparativa: l.comparativa
      };
      var cc = l.cropCalidad || l.crop, cropAntes = l.crop;
      var datos = await analyse(nuevo, this.cfg.fondoSeImprime);
      Object.assign(l, datos);
      l.file = nuevo; l.name = nuevo.name;
      if (tipo === 'bordes') l.cropCalidad = cc;
      else if (l.cropCalidad) l.cropCalidad = { w: cc.w * (l.crop.w / cropAntes.w), h: cc.h * (l.crop.h / cropAntes.h) };
      l.arreglos = anterior.arreglos.concat([tipo]);
      l.anterior = anterior;
      l.comparativa = comp;
      l.fondoFallido = false;
      if (tipo === 'fondo') l.tolFondo = nivel || 0;
      // el archivo recortado ya no tiene marco: el de antes era el que decía
      l.fondoClaro = anterior.fondoClaro;
    } catch (err) {
      this.flash(l.name + ': no hemos podido arreglarlo. Se queda como estaba.');
    }
    this.ocupado = false;
    this.renderList(); this.schedule();
  };

  /* ---------- panel de tolerancia y varita ---------- */
  Montador.prototype.abrirQF = async function (l) {
    if (this.ocupado || l.qf || !window.ImgArreglo) return;
    this.ocupado = true;
    try {
      // si ya se recortó el fondo, se retoca desde el archivo de antes del recorte
      var hechos = l.arreglos || [], fuente = (hechos[hechos.length - 1] === 'fondo' && l.anterior) ? l.anterior.file : l.file;
      var bmp = await createImageBitmap(fuente), k = Math.min(1, 800 / Math.max(bmp.width, bmp.height));
      var base = document.createElement('canvas'); base.width = Math.max(1, Math.round(bmp.width * k)); base.height = Math.max(1, Math.round(bmp.height * k));
      base.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0, base.width, base.height);
      if (bmp.close) bmp.close();
      l.qf = { fuente: fuente, base: base, tol: 1, modo: 'contiguo', varita: false, colores: [], vista: document.createElement('canvas'), ultimo: null, timer: null };
      l.qf.vista.className = 'mdtf-qf__cv';
      l.qf.vista.addEventListener('click', function (ev) { qfToque(l, ev); });
    } catch (e) { this.flash(l.name + ': no hemos podido abrirlo.'); }
    this.ocupado = false;
    if (l.qf) { this.pintarQF(l); this.previaQF(l); this.updateFixes(l); }
  };
  Montador.prototype.pintarQF = function (l) {
    var caja = this.root.querySelector('[data-id="' + l.id + '"] [data-qf]'), q = l.qf;
    if (!caja || !q) return;
    caja.hidden = false;
    caja.innerHTML =
      '<p class="mdtf-fix__t"><b>Borrador.</b> Ya ves el fondo quitado; dale a «Aplicar» si te vale. Sube la tolerancia si queda fondo; bájala si se come el dibujo. Con la varita tocas en el diseño otro color que quitar.</p>' +
      '<label class="mdtf-qf__tol">Tolerancia <b data-qf-tolv>' + q.tol + '</b><input type="range" name="qf-tol" min="0" max="100" value="' + q.tol + '" aria-label="Tolerancia"></label>' +
      '<div class="mdtf-qf__modo">' +
        '<label><input type="radio" data-qf-modo name="qf-modo-' + l.id + '" value="contiguo"' + (q.modo === 'contiguo' ? ' checked' : '') + '> Solo el fondo (desde los bordes)</label>' +
        '<label><input type="radio" data-qf-modo name="qf-modo-' + l.id + '" value="todo"' + (q.modo === 'todo' ? ' checked' : '') + '> Todo ese color</label>' +
      '</div>' +
      '<div class="mdtf-fix__btns"><button type="button" class="mdtf-fix__b' + (q.varita ? ' is-on' : '') + '" data-qf-act="varita">' +
        (q.varita ? '🪄 Toca en el diseño el color a quitar' : '🪄 Varita: quitar otro color') + '</button></div>' +
      (q.colores.length ? '<div class="mdtf-qf__chips">' + q.colores.map(function (c, i) {
        return '<span class="mdtf-qf__chip"><i style="background:rgb(' + c.r + ',' + c.g + ',' + c.b + ')"></i>' +
          '<button type="button" data-qf-act="chip" data-i="' + i + '" aria-label="Volver a poner este color">×</button></span>';
      }).join('') + '</div>' : '') +
      '<div class="mdtf-qf__lienzo' + (q.varita ? ' is-varita' : '') + '" data-qf-lienzo></div>' +
      '<p class="mdtf-muted" data-qf-nota></p>' +
      '<div class="mdtf-fix__btns"><button type="button" class="mdtf-fix__b" data-qf-act="ok">Aplicar</button>' +
        '<button type="button" class="mdtf-fix__b mdtf-fix__b--gris" data-qf-act="no">Cancelar</button></div>';
    caja.querySelector('[data-qf-lienzo]').appendChild(q.vista);
  };
  Montador.prototype.previaQF = function (l) {
    var q = l.qf; if (!q) return;
    clearTimeout(q.timer);
    q.timer = setTimeout(function () {
      var res = qfCalcular(q.base, q), v = q.vista, nota = null;
      var fuente = (res && res.ok) ? res.lienzo : q.base;
      q.ultimo = (res && res.ok) ? res.lienzo : null;
      v.width = fuente.width; v.height = fuente.height;
      v.getContext('2d').drawImage(fuente, 0, 0);
      var n = document.querySelector('[data-id="' + l.id + '"] [data-qf-nota]');
      if (n) n.textContent = q.ultimo ? '' : (res && res.motivo === 'agujereado'
        ? 'Con esta tolerancia se agujerea el dibujo: prueba con menos, o con «Todo ese color».'
        : 'No vemos un fondo liso que quitar. Prueba con «Todo ese color» o con la varita.');
    }, 120);
  };
  function qfToque(l, ev) {
    var q = l.qf; if (!q || !q.varita) return;
    var v = q.vista, r = v.getBoundingClientRect();
    var fx = (ev.clientX - r.left) / r.width, fy = (ev.clientY - r.top) / r.height;
    var x = Math.min(q.base.width - 1, Math.max(0, Math.round(fx * (q.base.width - 1)))), y = Math.min(q.base.height - 1, Math.max(0, Math.round(fy * (q.base.height - 1))));
    var px = q.base.getContext('2d').getImageData(x, y, 1, 1).data;
    if (px[3] < 8) return;   // ya es transparente: no hay color que quitar
    q.colores.push({ r: px[0], g: px[1], b: px[2], fx: fx, fy: fy });
    q.varita = false;
    Montador.prototype.pintarQF.call(l._montador, l);
    Montador.prototype.previaQF.call(l._montador, l);
  }
  Montador.prototype.accionQF = function (l, acto, boton) {
    var q = l.qf; if (!q) return;
    if (acto === 'varita') { q.varita = !q.varita; this.pintarQF(l); this.previaQF(l); }
    else if (acto === 'chip') { q.colores.splice(parseInt(boton.dataset.i, 10), 1); this.pintarQF(l); this.previaQF(l); }
    else if (acto === 'no') this.cerrarQF(l);
    else if (acto === 'ok') this.aplicarQF(l);
  };
  Montador.prototype.cerrarQF = function (l) {
    if (l.qf) clearTimeout(l.qf.timer);
    l.qf = null;
    var caja = this.root.querySelector('[data-id="' + l.id + '"] [data-qf]');
    if (caja) { caja.hidden = true; caja.innerHTML = ''; }
    this.updateFixes(l);
  };
  // a tamaño completo, con lo elegido, y el resultado sustituye al diseño (con «Deshacer»)
  Montador.prototype.aplicarQF = async function (l) {
    var q = l.qf; if (!q || this.ocupado) return;
    this.ocupado = true;
    var btn = this.root.querySelector('[data-id="' + l.id + '"] [data-qf-act="ok"]');
    if (window.Cargando && btn) { Cargando.ocupar(btn, 'Quitando el fondo…'); await Cargando.pinta(); }
    try {
      var bmp = await createImageBitmap(q.fuente);
      var orig = document.createElement('canvas'); orig.width = bmp.width; orig.height = bmp.height;
      orig.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      var res = qfCalcular(orig, q);
      if (!res.ok) { this.ocupado = false; this.flash(l.name + ': con esos ajustes no queda nada que quitar.'); this.pintarQF(l); this.previaQF(l); return; }
      var base = l.name.replace(/\.[^.]+$/, '').replace(/-sin-fondo$/, '');
      var nuevo = await ImgArreglo.aFichero(res.lienzo, base + '-sin-fondo.png');
      if (nuevo.size > this.cfg.maxFileMb * 1048576) { this.ocupado = false; this.flash('El archivo pesa más de ' + this.cfg.maxFileMb + ' MB. Se queda como estaba.'); this.pintarQF(l); this.previaQF(l); return; }
      var comp = null;
      try { comp = ImgArreglo.comparar(orig, res.lienzo, 440, 300); } catch (e) { comp = null; }
      // se parte del diseño de antes del recorte: si ya había uno, se deshace primero
      var hechos = l.arreglos || [];
      if (hechos[hechos.length - 1] === 'fondo' && l.anterior) this.deshacer(l, true);
      var anterior = {
        file: l.file, name: l.name, pxW: l.pxW, pxH: l.pxH, crop: l.crop,
        transparent: l.transparent, thumb: l.thumb, cropCalidad: l.cropCalidad,
        sobreNegro: l.sobreNegro, fondoClaro: l.fondoClaro, parteOscura: l.parteOscura, mockup: l.mockup,
        arreglos: (l.arreglos || []).slice(), comparativa: l.comparativa
      };
      var cc = l.cropCalidad || l.crop, cropAntes = l.crop;
      var datos = await analyse(nuevo, this.cfg.fondoSeImprime);
      Object.assign(l, datos);
      l.file = nuevo; l.name = nuevo.name;
      if (l.cropCalidad) l.cropCalidad = { w: cc.w * (l.crop.w / cropAntes.w), h: cc.h * (l.crop.h / cropAntes.h) };
      l.arreglos = anterior.arreglos.concat(['fondo']);
      l.anterior = anterior; l.comparativa = comp; l.fondoFallido = false; l.tolFondo = 0;
      l.fondoClaro = anterior.fondoClaro;
      clearTimeout(q.timer); l.qf = null;
    } catch (err) {
      this.flash(l.name + ': no hemos podido quitar el fondo. Se queda como estaba.');
    }
    this.ocupado = false;
    this.renderList(); this.schedule();
  };

  Montador.prototype.deshacer = function (l, callado) {
    if (!l.anterior) return;
    var a = l.anterior;
    l.file = a.file; l.name = a.name; l.pxW = a.pxW; l.pxH = a.pxH;
    l.crop = a.crop; l.transparent = a.transparent; l.thumb = a.thumb;
    l.sobreNegro = a.sobreNegro; l.fondoClaro = a.fondoClaro; l.parteOscura = a.parteOscura; l.mockup = a.mockup;
    l.cropCalidad = a.cropCalidad; l.arreglos = a.arreglos; l.comparativa = a.comparativa;
    l.anterior = null;
    if (!callado) { l.tolFondo = 0; l.fondoFallido = false; }
    // «callado»: lo llama ajustarFondo justo antes de recortar otra vez
    if (!callado) { this.renderList(); this.schedule(); }
  };

  Montador.prototype.flash = function (msg) {
    if (window.Cargando) Cargando.aviso(msg, 7000);
  };

  Montador.prototype.schedule = function () {
    var self = this; clearTimeout(this._t);
    // colocar 2.000 piezas lleva su rato: se avisa antes de empezar
    if (window.Cargando && this.logos.length) {
      Cargando.pill($(this.root, '[data-calculando]'), 'Buscando el montaje que menos film gasta…');
    }
    this._t = setTimeout(function () { self.compute(); }, 250);
  };

  Montador.prototype.valid = function () {
    var self = this;
    return this.logos.filter(function (l) { return !l.loading && l.qty > 0 && l.wCm > 0 && l.wCm <= self.maxWidthCm(l) + 0.001; });
  };

  Montador.prototype.compute = function () {
    var cfg = this.cfg, self = this, logos = this.valid(), total = 0;
    var wanted = this.logos.filter(function (l) { return !l.loading && l.qty > 0; });
    this.result = null;
    if (!logos.length || logos.length !== wanted.length) { this.renderResult(); return; }
    var pieces = [];
    logos.forEach(function (l) {
      var d = self.dims(l);
      for (var i = 0; i < l.qty; i++) pieces.push({ logo: l, w: d.w, h: d.h });
      total += l.qty;
    });
    if (total > cfg.maxPieces) { this.flash('Máximo ' + cfg.maxPieces + ' piezas por montaje. Para más, escríbenos por WhatsApp.'); this.renderResult(); return; }
    var opts = {};
    if (cfg.hoja.variant) {
      var hb = pack(pieces, cfg.hoja.w, cfg.hoja.h, this.gap);
      if (hb) opts.hoja = { key: 'hoja', bins: hb, W: cfg.hoja.w, H: cfg.hoja.h, cost: hb.length * cfg.hoja.variant.price,
        lines: [{ variant: cfg.hoja.variant, qty: hb.length }], label: hb.length + (hb.length === 1 ? ' hoja' : ' hojas') + ' de 40×50 cm' };
    }
    if (cfg.metro.packs.length) {
      var mb = pack(pieces, cfg.metro.w, cfg.metro.h, this.gap);
      if (mb) {
        var c = cheapestMetres(mb.length, cfg.metro.packs);
        opts.metro = { key: 'metro', bins: mb, W: cfg.metro.w, H: cfg.metro.h, cost: c.cost, lines: c.lines, metres: c.metres,
          label: c.metres + (c.metres === 1 ? ' metro' : ' metros') + ' de 55×100 cm' };
      }
    }
    var keys = Object.keys(opts);
    if (!keys.length) { this.flash('Algún diseño no cabe en ningún formato.'); this.renderResult(); return; }
    keys.sort(function (a, b) { return opts[a].cost - opts[b].cost || opts[a].bins.length - opts[b].bins.length; });
    this.result = { opts: opts, cheapest: keys[0], pieces: total };
    if (!this.userChoice || !opts[this.choice]) { this.choice = keys[0]; this.userChoice = false; }
    this.sheetIdx = 0;
    this.renderResult();
  };

  Montador.prototype.lowRes = function () {
    var self = this;
    return this.valid().some(function (l) { return self.dims(l).dpi < self.cfg.dpiMin; });
  };

  Montador.prototype.renderResult = function () {
    var r = this.root, res = this.result, self = this;
    if (window.Cargando) Cargando.pill($(r, '[data-calculando]'), null);
    r.querySelectorAll('[data-result]').forEach(function (x) { x.hidden = !res; });
    // si no hay montaje que enseñar, decir por qué justo debajo de la lista (antes desaparecía sin más)
    var bq = $(r, '[data-bloqueo]');
    if (bq) {
      var malos = res ? [] : this.logos.filter(function (l) {
        return !l.loading && l.qty > 0 && !(l.wCm > 0 && l.wCm <= self.maxWidthCm(l) + 0.001);
      });
      var cargando = !res && this.logos.some(function (l) { return l.loading; });
      bq.hidden = !malos.length;
      if (malos.length) {
        bq.textContent = 'El montaje no se muestra porque ' + (malos.length === 1 ? 'este diseño tiene el ancho vacío o demasiado grande: ' : 'estos diseños tienen el ancho vacío o demasiado grande: ') +
          malos.map(function (l) { return l.name; }).join(', ') + '. Corrígelo y aparecerá aquí abajo.';
      }
      if (cargando) bq.hidden = true;
    }
    $(r, '[data-accept-wrap]').hidden = !(res && this.lowRes());
    if (res) {
      $(r, '[data-options]').innerHTML = ['hoja', 'metro'].filter(function (k) { return res.opts[k]; }).map(function (k) {
        var o = res.opts[k], used = 0;
        o.bins.forEach(function (b) { b.forEach(function (p) { used += p.w * p.h; }); });
        var eff = Math.round(100 * used / (o.bins.length * o.W * o.H));
        var extra = [];
        if (k === 'metro' && o.lines.length > 1) extra.push(o.lines.map(function (l) { return l.qty + ' × ' + l.variant.title; }).join(' + '));
        if (k === 'metro' && o.metres > o.bins.length) extra.push('tu montaje ocupa ' + o.bins.length + ' m, pero el pack de ' + o.metres + ' m sale más barato');
        var sel = self.choice === k;
        return '<label class="mdtf-opt' + (sel ? ' is-selected' : '') + '">' +
          '<input type="radio" name="formato" value="' + k + '"' + (sel ? ' checked' : '') + '>' +
          '<span class="mdtf-opt__main"><span class="mdtf-opt__title">' + o.label +
            (res.cheapest === k && Object.keys(res.opts).length > 1 ? ' <span class="mdtf-badge mdtf-badge--ok">Más barato</span>' : '') + '</span>' +
          '<span class="mdtf-muted">' + fmt(res.pieces, 0) + ' piezas · aprovechamiento ' + eff + ' %' + (extra.length ? ' · ' + extra.join(' · ') : '') + '</span></span>' +
          '<span class="mdtf-opt__price">' + money(o.cost) + '</span>' +
        '</label>';
      }).join('');
      this.drawPreview();
      var rs = $(r, '[data-resumen]'), oc = res.opts[this.choice];
      if (rs && oc) rs.textContent = oc.label + ' · ' + fmt(res.pieces, 0) + (res.pieces === 1 ? ' pieza' : ' piezas');
    }
    this.updateButton();
  };

  Montador.prototype.updateButton = function () {
    var btn = $(this.root, '[data-add]'), res = this.result;
    var needAccept = !$(this.root, '[data-accept-wrap]').hidden && !$(this.root, '[data-accept]').checked;
    if (!this.busy && window.Cargando) Cargando.libre(btn);
    btn.disabled = !res || needAccept || this.busy;
    var bP = $(this.root, '[data-presupuesto]');
    if (bP) bP.disabled = btn.disabled;
    var mini = $(this.root, '[data-mini]');
    if (mini) { mini.hidden = !res; var mt = $(mini, '[data-mini-txt]'); if (mt && res) mt.textContent = res.opts[this.choice].label + ' · ' + money(res.opts[this.choice].cost); }
    if (!this.busy) btn.textContent = res ? 'Añadir al carrito · ' + money(res.opts[this.choice].cost) : 'Añadir al carrito';
  };

  /* una miniatura por metro/hoja bajo el pliego; al pulsarla se ve ese */
  Montador.prototype.dibujaMiniaturas = function (o) {
    var self = this, box = $(this.root, '[data-thumbs]'); if (!box) return;
    var n = o.bins.length; box.hidden = n < 2; box.innerHTML = '';
    if (n < 2) return;
    var pista = document.createElement('div'); pista.className = 'mdtf-thumbs__pista';
    function flecha(txt, dir, lab) {
      var f = document.createElement('button'); f.type = 'button'; f.className = 'mdtf-thumbs__flecha'; f.textContent = txt;
      f.setAttribute('aria-label', lab);
      f.addEventListener('click', function () { pista.scrollBy({ left: dir * pista.clientWidth * 0.8, behavior: 'smooth' }); });
      return f;
    }
    box.appendChild(flecha('‹', -1, 'Metros anteriores')); box.appendChild(pista); box.appendChild(flecha('›', 1, 'Metros siguientes'));
    var tw = 46, th = Math.round(tw * o.H / o.W), dpr = window.devicePixelRatio || 1, k = tw / o.W;
    o.bins.forEach(function (bin, i) {
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'mdtf-thumb' + (i === self.sheetIdx ? ' is-activa' : '');
      b.setAttribute('aria-label', (o.key === 'hoja' ? 'Hoja ' : 'Metro ') + (i + 1));
      var c = document.createElement('canvas'); c.width = Math.round(tw * dpr); c.height = Math.round(th * dpr);
      c.style.width = tw + 'px'; c.style.height = th + 'px';
      var x = c.getContext('2d'); x.scale(dpr * k, dpr * k);
      x.fillStyle = '#93939a'; x.fillRect(0, 0, o.W, o.H);
      bin.forEach(function (p) {
        var img = p.logo.thumb; x.save();
        if (p.r) { x.translate(p.x + p.w, p.y); x.rotate(Math.PI / 2); x.drawImage(img, 0, 0, p.h, p.w); }
        else x.drawImage(img, p.x, p.y, p.w, p.h);
        x.restore();
      });
      var num = document.createElement('span'); num.textContent = i + 1;
      b.appendChild(c); b.appendChild(num);
      b.addEventListener('click', function () { self.sheetIdx = i; self.drawPreview(); });
      pista.appendChild(b);
    });
    var act = pista.querySelector('.is-activa');
    if (act) pista.scrollLeft = act.offsetLeft - (pista.clientWidth - act.offsetWidth) / 2;
  };

  Montador.prototype.drawPreview = function () {
    var res = this.result; if (!res) return;
    var o = res.opts[this.choice], canvas = $(this.root, '[data-canvas]'), n = o.bins.length;
    this.sheetIdx = Math.max(0, Math.min(n - 1, this.sheetIdx));
    $(this.root, '[data-sheet-label]').textContent = (o.key === 'hoja' ? 'Hoja ' : 'Metro ') + (this.sheetIdx + 1) + ' de ' + n;
    $(this.root, '[data-prev]').disabled = this.sheetIdx === 0;
    $(this.root, '[data-next]').disabled = this.sheetIdx >= n - 1;
    $(this.root, '[data-pager]').hidden = true;
    this.dibujaMiniaturas(o);
    var caja = canvas.parentElement, estilo = window.getComputedStyle(caja);
    var relleno = parseFloat(estilo.paddingLeft) + parseFloat(estilo.paddingRight);
    var maxW = Math.max(160, (caja.clientWidth || 320) - relleno), maxH = window.innerWidth < 990 ? Math.max(200, window.innerHeight * 0.38) : Math.max(200, window.innerHeight - caja.getBoundingClientRect().top - 200);
    var s = Math.min(maxW / o.W, maxH / o.H), dpr = window.devicePixelRatio || 1;
    canvas.style.width = Math.round(o.W * s) + 'px'; canvas.style.height = Math.round(o.H * s) + 'px';
    canvas.width = Math.round(o.W * s * dpr); canvas.height = Math.round(o.H * s * dpr);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr * s, 0, 0, dpr * s, 0, 0);
    // gris neutro: sobre el film se ven igual de bien los diseños blancos y los negros
    for (var y = 0; y < o.H; y += 20) for (var x = 0; x < o.W; x += 20) {
      ctx.fillStyle = ((x + y) / 20) % 2 ? '#8e8e93' : '#98989d';
      ctx.fillRect(x, y, 20, 20);
    }
    o.bins[this.sheetIdx].forEach(function (p) {
      var img = p.logo.thumb;
      ctx.save();
      if (p.r) { ctx.translate(p.x + p.w, p.y); ctx.rotate(Math.PI / 2); ctx.drawImage(img, 0, 0, p.h, p.w); }
      else ctx.drawImage(img, p.x, p.y, p.w, p.h);
      ctx.restore();
    });
    // contorno fino de cada pieza, para que un logo blanco no se funda con otro
    ctx.strokeStyle = 'rgba(0,0,0,.28)'; ctx.lineWidth = 1 / s;
    o.bins[this.sheetIdx].forEach(function (p) { ctx.strokeRect(p.x, p.y, p.w, p.h); });
    ctx.strokeStyle = 'rgba(0,0,0,.5)'; ctx.lineWidth = 2 / s; ctx.strokeRect(0, 0, o.W, o.H);
  };

  /* CON SEMITONO, AL TALLER VA EL ORIGINAL con su fondo (Xavi, 26/09): el
     fundido y la trama los hace su panel. El recorte medido sobre el
     fundido vale igual para el original: tienen los mismos píxeles. */
  function archivoTaller(l) {
    var o = l;
    while (o.anterior && (o.arreglos || []).indexOf('negro') !== -1) o = o.anterior;
    return o.file ? { file: o.file, name: o.name } : { file: l.file, name: l.name };
  }

  /* Archivo que sube al carrito: si pesa mucho más de lo que hace falta (p. ej. 6000 px para un logo de 10 cm), se reduce a 300 ppp reales
     de ese tamaño. Con varios logos grandes la petición pasaba del límite de Shopify (error 413). Nunca se amplía ni se baja de 300 ppp. */
  async function archivoSubida(l, self) {
    var t = archivoTaller(l);
    if (!t.file || t.file.size < 1.5 * 1048576 || !window.createImageBitmap) return t;
    try {
      var d = self.dims(l), f = Math.min(1, 300 / Math.max(1, d.dpi));
      if (f > 0.8) return t;
      var bmp = await createImageBitmap(t.file), w = Math.max(64, Math.round(bmp.width * f)), h = Math.max(64, Math.round(bmp.height * f));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(bmp, 0, 0, w, h);
      var blob = await new Promise(function (ok) { c.toBlob(ok, 'image/png'); });
      if (blob && blob.size < t.file.size) return { file: new File([blob], t.name.replace(/\.[^.]+$/, '') + '.png', { type: 'image/png' }), name: t.name.replace(/\.[^.]+$/, '') + '.png' };
    } catch (e) { /* se sube el original */ }
    return t;
  }

  /* Resumen para el pedido: texto legible por logo + JSON para el panel de Python */
  Montador.prototype.summary = function (o, id) {
    var self = this, logos = this.valid(), idx = {};
    logos.forEach(function (l, i) { idx[l.id] = i + 1; });
    var data = {
      v: 1, id: id, formato: o.key, pliego_mm: [o.W, o.H], separacion_mm: this.gap,
      pliegos: o.bins.length, compra: o.lines.map(function (l) { return { sku: l.variant.sku, uds: l.qty }; }),
      logos: logos.map(function (l, i) {
        var d = self.dims(l);
        return { n: i + 1, propiedad: 'Logo ' + (i + 1), archivo: archivoTaller(l).name, px: [l.pxW, l.pxH],
          recorte_px: [l.crop.x, l.crop.y, l.crop.w, l.crop.h], mm: [+d.w.toFixed(1), +d.h.toFixed(1)],
          uds: l.qty, ppp: Math.round(d.dpi) };
      })
    };
    // colocación: [pliego, logo, x_mm, y_mm, girado 90° horario]
    var layout = [];
    o.bins.forEach(function (b, bi) { b.forEach(function (p) { layout.push([bi + 1, idx[p.logo.id], +p.x.toFixed(1), +p.y.toFixed(1), p.r ? 1 : 0]); }); });
    data.colocacion = layout;
    var json = JSON.stringify(data);
    if (json.length > this.cfg.maxJson) { delete data.colocacion; data.colocacion_omitida = true; json = JSON.stringify(data); }
    return json;
  };

  Montador.prototype.addToCart = async function (pres) {
    var res = this.result; if (!res || this.busy) return;
    var esPres = pres === true, bP = $(this.root, '[data-presupuesto]'), notaP = $(this.root, '[data-presupuesto-nota]'), antesP = '';
    if (esPres) {
      if (!window.Presupuesto || !this.cfg.presupuestoUrl || !bP) return;
      antesP = bP.textContent;
    }
    var self = this, o = res.opts[this.choice], btn = $(this.root, '[data-add]'), root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var id = 'M-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
    var main = o.lines[0], extra = o.lines.slice(1), logos = this.valid();
    var fields = [
      ['id', main.variant.id], ['quantity', main.qty],
      ['properties[Montaje]', id],
      ['properties[Formato]', o.label + (o.lines.length > 1 ? ' (' + o.lines.map(function (l) { return l.qty + ' × ' + l.variant.title; }).join(' + ') + ')' : '')],
      ['properties[Piezas]', String(res.pieces)]
    ];
    logos.forEach(function (l, i) {
      var d = self.dims(l);
      /* Los arreglos van en la MISMA línea del logo, no en una propiedad aparte:
         así el que monta el pliego lee "TRAMAR puntos45" justo al lado del
         archivo al que se lo tiene que hacer. */
      var arr = (l.arreglos || []).map(pedido).join(' · ');
      fields.push(['properties[Logo ' + (i + 1) + ' medidas]', fmt(d.w / 10, 1) + ' × ' + fmt(d.h / 10, 1) + ' cm × ' + l.qty + ' uds · ' + Math.round(d.dpi) + ' ppp · ' + archivoTaller(l).name + (arr ? ' · ' + arr : '')]);
    });
    fields.push(['properties[_montaje_json]', this.summary(o, id)]);

    /* PRESUPUESTO LISTO PARA PAGAR: las mismas líneas y archivos que irían al carrito, a un pedido borrador. */
    if (esPres) {
      this.busy = true; bP.disabled = true; btn.disabled = true; bP.textContent = 'Preparando presupuesto…';
      var fdP = new FormData();
      fields.forEach(function (f) { fdP.append(f[0], f[1]); });
      var archP = await Promise.all(logos.map(function (l) { return archivoSubida(l, self); }));
      archP.forEach(function (t, i) { fdP.append('properties[Logo ' + (i + 1) + ']', t.file, t.name); });
      var datosP = Presupuesto.desdeForm(fdP, extra.map(function (l) { return { id: l.variant.id, quantity: l.qty, properties: { Montaje: id, Formato: 'Parte del montaje ' + id } }; }));
      var tituloP = (document.querySelector('h1') || document).textContent.replace(/\s+/g, ' ').trim() || 'Montaje DTF';
      var self2 = this;
      try {
        var creado = await Presupuesto.crear(this.cfg.presupuestoUrl, { titulo: tituloP.slice(0, 120), nota: '', lineas: datosP.lineas, ficheros: datosP.ficheros });
        var total = creado.total ? money(Math.round(parseFloat(creado.total) * 100)) : '';
        creado.totalTexto = total ? total + ' IVA incl.' : '';
        var texto = 'Presupuesto de Imprimirlo · ' + tituloP + '\n' + (total ? 'Precio: ' + total + ' IVA incl.\n' : '') +
          (creado.landing ? 'Mira el montaje y págalo aquí: ' + creado.landing : 'Págalo aquí: ' + creado.url);
        var copiado = false;
        if (!Presupuesto.esMovil() && navigator.clipboard) { try { await navigator.clipboard.writeText(texto); copiado = true; } catch (e2) { /* sin portapapeles */ } }
        Presupuesto.mostrar(notaP, creado, texto, copiado);
      } catch (e) {
        self2.flash((e && e.message) || 'No se ha podido preparar el presupuesto. Inténtalo otra vez o escríbenos por WhatsApp.');
      }
      this.busy = false; bP.textContent = antesP; this.updateButton();
      return;
    }

    this.busy = true;
    var textoSubida = logos.length > 1 ? 'Subiendo los diseños' : 'Subiendo el diseño';
    if (window.Cargando) Cargando.ocupar(btn, textoSubida + '…', true);
    else { btn.disabled = true; btn.textContent = textoSubida + '…'; }
    try {
      var fd = new FormData();
      fields.forEach(function (f) { fd.append(f[0], f[1]); });
      if (window.Cargando) Cargando.ocupar(btn, 'Preparando los diseños…', true);
      var archivos = await Promise.all(logos.map(function (l) { return archivoSubida(l, self); }));
      var totalMB = archivos.reduce(function (s, t) { return s + t.file.size; }, 0) / 1048576;
      /* Con archivos pesados se suben primero al Worker (Shopify Files) y el carrito lleva solo el ENLACE: así no hay límite de 413.
         Si el Worker no está o falla, se hace como siempre (el archivo dentro del carrito). */
      var enlaces = null;
      if (totalMB > 6 && this.cfg.presupuestoUrl) {
        try {
          enlaces = [];
          for (var q = 0; q < archivos.length; q++) {
            if (window.Cargando) Cargando.ocupar(btn, 'Subiendo el diseño ' + (q + 1) + ' de ' + archivos.length + '…', true);
            var fdA = new FormData(); fdA.append('archivo', archivos[q].file, archivos[q].name);
            var ra = await fetch(this.cfg.presupuestoUrl.replace(/\/$/, '') + '/archivo', { method: 'POST', body: fdA });
            var ja = null; try { ja = await ra.json(); } catch (e0) { /* sin cuerpo */ }
            if (!ra.ok || !ja || !ja.ok || !ja.url) throw new Error((ja && ja.error) || 'worker');
            enlaces.push(ja.url);
          }
        } catch (eW) { enlaces = null; console.warn('[montador] subida por el Worker no disponible, se envía en el carrito', eW && eW.message); }
      }
      if (enlaces) totalMB = 0;     // ya no viajan archivos en la petición del carrito
      if (enlaces) enlaces.forEach(function (u, i) { fd.append('properties[Logo ' + (i + 1) + ']', u); });
      else archivos.forEach(function (t, i) { fd.append('properties[Logo ' + (i + 1) + ']', t.file, t.name); });
      var r, item;
      if (window.Cargando) {
        r = await Cargando.subir(root + 'cart/add.js', fd, function (p) {
          if (p >= 100) Cargando.ocupar(btn, 'Guardando el montaje…');
          else Cargando.pct(btn, p, textoSubida);
        });
        if (!r.ok) throw new Error('multipart');
        item = r.json;
      } else {
        r = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('multipart');
        item = await r.json();
      }
      var props = (item && item.properties) || {};
      if (!/^https?:\/\//.test(String(props['Logo 1'] || ''))) console.warn('[montador] la propiedad Logo 1 no llegó como URL', props['Logo 1']);
      if (extra.length) {
        if (window.Cargando) Cargando.ocupar(btn, 'Añadiendo los metros…');
        else btn.textContent = 'Añadiendo al carrito…';
        var r2 = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extra.map(function (l) { return { id: l.variant.id, quantity: l.qty, properties: { Montaje: id, Formato: 'Parte del montaje ' + id } }; }) })
        });
        if (!r2.ok) throw new Error('No se ha podido añadir el resto de metros al carrito.');
      }
      window.location.href = root + 'cart';
    } catch (err) {
      if (err && err.message === 'multipart' && typeof totalMB === 'number' && totalMB > 8) {   // el formulario clásico daría la misma página de error 413
        this.busy = false; this.updateButton();
        this.flash('Los diseños pesan ' + Math.round(totalMB) + ' MB en total y el carrito no los admite. ' + (this.cfg.presupuestoUrl ? 'Pulsa «Crear presupuesto»: ese sí admite archivos grandes y te da un enlace para pagar. ' : '') + 'O súbelos más ligeros (menos píxeles), o escríbenos por WhatsApp y los recibimos nosotros.');
        return;
      }
      if (err && err.message === 'multipart' && !extra.length) return this.submitForm(fields, logos);
      this.busy = false; this.flash(err && err.message && err.message !== 'multipart' ? err.message : 'No se ha podido añadir al carrito. Inténtalo de nuevo o escríbenos por WhatsApp.');
      this.updateButton();
    }
  };

  // alternativa: formulario multipart clásico hacia /cart/add (recarga y va al carrito)
  Montador.prototype.submitForm = function (fields, logos) {
    var form = $(this.root, '[data-cart-form]');
    form.innerHTML = '';
    fields.concat([['form_type', 'product'], ['utf8', '✓']]).forEach(function (f) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = f[0]; i.value = f[1]; form.appendChild(i);
    });
    logos.forEach(function (l, n) {
      var fi = document.createElement('input'); fi.type = 'file'; fi.name = 'properties[Logo ' + (n + 1) + ']';
      var dt = new DataTransfer(); dt.items.add(l.file); fi.files = dt.files; form.appendChild(fi);
    });
    form.submit();
  };

  function init() {
    /* móvil: una columna cada vez (Diseños / Pliego / Pedido) */
    document.querySelectorAll('[data-montador-dtf]').forEach(function (raiz) {
      if (raiz._tabs) return; raiz._tabs = true;
      function ir(n) {
        raiz.dataset.tab = n;
        raiz.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.tabBtn === String(n)); });
        var g = raiz.querySelector('.mdtf__grid'); if (g) g.scrollTop = 0;
        if (n === 2 && raiz._montador) raiz._montador.drawPreview();
      }
      raiz.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab-btn]'); if (b) { ir(b.dataset.tabBtn); return; }
        if (e.target.closest('[data-mini]')) ir(3);
      });
    });
    document.querySelectorAll('[data-montador-dtf]').forEach(function (el) { if (!el._montador) { el._montador = new Montador(el); document.documentElement.classList.add('mdtf-abierto'); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();